import React from 'react';
import { 
  Card, 
  Typography, 
  List, 
  Space, 
  Button, 
  Divider, 
  Row, 
  Col 
} from 'antd';
import { 
  PhoneOutlined, 
  MailOutlined, 
  GlobalOutlined, 
  GithubOutlined, 
  LinkedinOutlined, 
  MessageOutlined
} from '@ant-design/icons';

const { Title, Text, Paragraph } = Typography;

export const SupportContact = ({ setLoading, showMessage, supportLinks }) => {
     // لینک‌های پشتیبانی
  
    const contactItems = [
        {
            icon: <PhoneOutlined />,
            title: 'تلفن پشتیبانی',
            value: supportLinks.phone,
            action: 'تماس',
            link: `tel:${supportLinks.phone}`
        },
        {
            icon: <MailOutlined />,
            title: 'ایمیل پشتیبانی',
            value: supportLinks.email,
            action: 'ارسال ایمیل',
            link: `mailto:${supportLinks.email}`
        },
        {
            icon: <GlobalOutlined />,
            title: 'وب‌سایت',
            value: supportLinks.website,
            action: 'مراجعه',
            link: supportLinks.website
        },
        // {
        //     icon: <GithubOutlined />,
        //     title: 'GitHub',
        //     value: 'مخزن پروژه',
        //     action: 'مشاهده',
        //     link: supportLinks.github
        // },
        // {
        //     icon: <LinkedinOutlined />,
        //     title: 'LinkedIn',
        //     value: 'صفحه شرکت',
        //     action: 'مشاهده',
        //     link: supportLinks.linkedin
        // }
    ];

    return (
        <div style={{ padding: 24 }}>
            <Card>
                <Title level={3}>ارتباط با پشتیبانی</Title>
                <Paragraph type="secondary">
                    برای دریافت پشتیبانی فنی، گزارش مشکلات و پیشنهادات می‌توانید از راه‌های زیر با ما در ارتباط باشید.
                </Paragraph>
                
                <Divider />
                
                <Row gutter={[16, 16]}>
                    {contactItems.map((item, index) => (
                        <Col xs={24} sm={12} md={8} key={index}>
                            <Card 
                                hoverable
                                style={{ height: '100%' }}
                                onClick={() => window.open(item.link, '_blank')}
                            >
                                <Space direction="vertical" align="center" style={{ width: '100%' }}>
                                    <div style={{ fontSize: 32, color: '#1890ff' }}>
                                        {item.icon}
                                    </div>
                                    <Title level={5}>{item.title}</Title>
                                    <Text type="secondary">{item.value}</Text>
                                    <Button type="primary" style={{ marginTop: 8 }}>
                                        {item.action}
                                    </Button>
                                </Space>
                            </Card>
                        </Col>
                    ))}
                </Row>
                
                <Divider />
                
                <Title level={4}>ساعات پاسخگویی</Title>
                <List>
                    <List.Item>
                        <Text strong>شنبه تا چهارشنبه:</Text>
                        <Text> 7:00 صبح تا 14:00 عصر</Text>
                    </List.Item>
                    <List.Item>
                        <Text strong>پنجشنبه:</Text>
                        <Text> 7:00 صبح تا 12:00 عصر</Text>
                    </List.Item>
                </List>
            </Card>
        </div>
    );
};